export default {
  title: 'Perfis de Acesso',
  description: 'Crie perfis que agrupam permissões para facilitar a concessão de acesso aos usuários.',
  labels: {
    new: 'Novo Perfil',
    dataRole: 'Dados do Perfil',
    users: 'Usuários',
    roles: 'Perfis de Acesso'
  },
  
  form:{
    title: 'Cadastro do Perfil de Acesso'
  },
  fields: {
    name: 'Nome do Perfil',
  },
  listUsers: {
    source: 'Cadastrados',
    catalog: 'Disponíveis',
    target: 'Incluídos',
  }
};
